import type { ResourceType } from '@/api/specifications/specifications.types';

export type Selection = ReadonlySet<string>;

export interface MergeTarget {
  resource: ResourceType;
  sourceId: number;
  sourceLabel: string;
  scope: {
    manufacturerId?: number;
    category?: string;
    productLineId?: number;
    attribute?: string;
  };
}

export interface SelectedItem {
  resource: ResourceType;
  id: number;
}

/** "productLine:42" → { resource: 'productLine', id: 42 } */
export function parseSelectionKey(key: string): SelectedItem {
  const [resource, idStr] = key.split(':');
  return { resource: resource as ResourceType, id: Number(idStr) };
}
